import React from "react";
import VideoTypes from "./VideoTypes";

export default function ListTemplate(props) {
    if(props.list?.length > 0){
        props.list.forEach(function(item) {
            if(item.gameType == 4201){
                item.gameTypeName = "KBO";
            } else if(item.gameType == 4206){
                if(props.useLang == "en"){
                    item.gameTypeName = "Futures";
                } else {
                    item.gameTypeName = "퓨쳐스";
                }
            } else if(item.gameType == 4212){
                if(props.useLang == "en"){
                    item.gameTypeName = "R.squard";
                } else {
                    item.gameTypeName = "육성군";
                }
            } else if(item.gameType == 4202){
                if(props.useLang == "en"){
                    item.gameTypeName = "PS";
                } else {
                    item.gameTypeName = "포스트시즌";
                }
            } else if(item.gameType == 4203){
                if(props.useLang == "en"){
                    item.gameTypeName = "PS";
                } else {
                    item.gameTypeName = "포스트시즌";
                }
            } else if(item.gameType == 4204){
                if(props.useLang == "en"){
                    item.gameTypeName = "PS";
                } else {
                    item.gameTypeName = "포스트시즌";
                }
            } else if(item.gameType == 4205){
                if(props.useLang == "en"){
                    item.gameTypeName = "PS";
                } else {
                    item.gameTypeName = "포스트시즌";
                }
            } else if(item.gameType == 4208){
                if(props.useLang == "en"){
                    item.gameTypeName = "M.scrim";
                } else {
                    item.gameTypeName = "1군연습";
                }
            } else if(item.gameType == 4213){
                if(props.useLang == "en"){
                    item.gameTypeName = "F.scrim";
                } else {
                    item.gameTypeName = "2군연습";
                }
            } else if(item.gameType == 4207){
                if(props.useLang == "en"){
                    item.gameTypeName = "Exhib.";
                } else {
                    item.gameTypeName = "시범";
                }
            } else if(item.gameType == 4214){
                if(props.useLang == "en"){
                    item.gameTypeName = "Edu.";
                } else {
                    item.gameTypeName = "교육";
                }
            }
        });

    }

    if(props.list?.length > 0){
        return(
            <React.Fragment>
                {props.list.map((game, idx) => (
                    <tr key={game.gameInfoId}>
                        <td style={{width:"83%", padding:"0px", borderTop:"none"}}>
                            <table id={"leftRow_"+idx} style={{width:"100%", textAlign:"center",backgroundColor:"", fontSize:"13px", tableLayout:"fixed"}} name={game.name} className={game.className} rel={game.gameInfoId} onClick={props.selectGameHandler}>
                                <tbody>
                                    <tr style={game.initialPitchTime == (null || undefined || "") ? {color: "lightgrey"} : null}>
                                        <td style={{width:"10%"}}>
                                            {game.initialPitchTime == (null || undefined || "") ? <span style={{ color: "red", fontSize: 17 }}>*</span> : null}
                                            {game.gameCnt}
                                        </td>
                                        <td style={{width:"15%"}}>{game.gameDay}<br/>{game.gameTypeName}</td>
                                        <td style={{width:"25%", textOverflow:"ellipsis", overflow:"hidden"}}>
                                            {props.useLang === 'en' ? game.awayShortName : game.awayTeamName}<br/>
                                            #{game.awayPitcherBacknum}&nbsp;
                                            {props.useLang === 'en' 
                                                ? (game.awayPitcherForeignerYn == "Y" ? game.awayPitcherLastName : game.awayPitcherLastName + " " + game.awayPitcherShortName)  
                                                : game.awayBeginPitcher
                                            }
                                        </td>
                                        {game.initialPitchTime == (null || undefined || "") 
                                            ? <td style={{width:"15%"}}>
                                                    <span>{game.awayTeamScore}</span> : <span>{game.homeTeamScore}</span>
                                                </td>
                                            : (Number(game.awayTeamScore) > Number(game.homeTeamScore)
                                                ? <td style={{width:"15%"}}>
                                                    <span className="winScore">{game.awayTeamScore}</span> : <span>{game.homeTeamScore}</span>
                                                </td>
                                                : (Number(game.awayTeamScore) < Number(game.homeTeamScore) 
                                                    ? <td style={{width:"15%"}}>
                                                        <span>{game.awayTeamScore}</span> : <span className="winScore">{game.homeTeamScore}</span>
                                                    </td>
                                                    : <td style={{width:"15%"}}>
                                                        <span>{game.awayTeamScore}</span> : <span>{game.homeTeamScore}</span>
                                                    </td>
                                                )
                                            )
                                        }
                                        <td style={{width:"25%", borderRight:"none", textOverflow:"ellipsis", overflow:"hidden"}}>
                                            {props.useLang === 'en' ? game.homeShortName : game.homeTeamName}<br/>
                                            #{game.homePitcherBacknum}&nbsp;
                                            {props.useLang === 'en' 
                                                ? (game.homePitcherForeignerYn == "Y" ? game.homePitcherLastName : game.homePitcherLastName + " " + game.homePitcherShortName)  
                                                : game.homeBeginPitcher
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                ))}
            </React.Fragment>
        )
        
    } else {
        return (
            <>
                {props.listLoading 
                    ? <tr>
                        <td>
                            <div style={{height: "50px"}} />
                        </td>
                    </tr>
                    : <tr>
                        <td style={{border:"none"}}>
                            <div style={{fontSize:"20px", textAlign:"center"}}>
                                {props.useLang === "en" ? "There are no games that match on filters" : "해당하는 경기가 없습니다."}
                            </div>
                        </td>
                    </tr>
                }
            </>
        )
    }

}